import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCommonService } from 'src/app-core/services/api-common.service';
import { CommonService } from 'src/app-core/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class PopupService {

  constructor(
    private apiCommonService: ApiCommonService,
    private commonService: CommonService) {
  }

  popup(data: object): Observable<any> {
    return this.apiCommonService.post('Popup', data);
  }

  getPopupGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
    return this.apiCommonService.getGridRecords('Popup', event, searchQuery, statusQuery, '');
  }

    getPopup(id: string): Observable<any> {
    return this.apiCommonService.get(`Popup/Edit?PopupId=${id}`);
  }

  updatePopup(data: object): Observable<any> {
    return this.apiCommonService.post('Popup/Update', data);
  }

  popupStatusUpdate(data: object): Observable<object> {
    return this.apiCommonService.put('Popup/Delete', data);
  }

  getPopupListForAccount(AccountId: string): Observable<any> {
    return this.apiCommonService.get(`Popup/ListForAccount?AccountId=${AccountId}`);
  }

  updatePopupStatus(data: any): Observable<any> {
    return this.apiCommonService.post('Popup/UpdateStatus', data);
  }

}
